import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Discussions } from "@air/next-icons";
import { memo } from "react";
export const EmptyComments = /*#__PURE__*/ memo(()=>/*#__PURE__*/ _jsxs("div", {
        className: "flex h-full flex-col items-center justify-center gap-4 p-4",
        children: [
            /*#__PURE__*/ _jsx(Discussions, {
                className: "size-[72px] text-grey-7"
            }),
            /*#__PURE__*/ _jsx("p", {
                className: "text-20 font-medium text-grey-8",
                children: "No comments"
            }),
            /*#__PURE__*/ _jsx("p", {
                className: "text-center text-14 text-grey-8",
                children: "Start reviewing assets and giving feedback with comments and annotations"
            })
        ]
    }));
EmptyComments.displayName = "EmptyComments";
